import $ from 'jquery';
import 'bootstrap/js/modal';
import amplitude from 'application/trackable/amplitude';

export default function hookAmplitudeEvents() {
  const helpCenterAttendanceLink = $('.js-help-center-link');
  const contactUsLink = $('.js-contact-us-link');
  const whatsAppAttendanceLink = $('.js-whats-app-attendance-link');
  const phoneAttendanceLink = $('.js-phone-attendance-link');
  const helpAttendenceLink = $('.js-help-center-link');

  helpCenterAttendanceLink.on('click', () => {
    amplitude.track('ClickedHelpCenterLink');
  });

  contactUsLink.on('click', () => {
    amplitude.track('ClickedContactUsLInk');
  });

  whatsAppAttendanceLink.on('click', () => {
    amplitude.track('ClickedWhatsAppAttendance');
  });

  phoneAttendanceLink.on('click', () => {
    amplitude.track('ClickedPhoneAttendance');
  });

  helpAttendenceLink.on('click', () => {
    amplitude.track('ClickedHelpAttendance');
  });
}
